import React, { useContext } from 'react';
import styled from '@emotion/styled';
import type { WCmsHomepageView, WPublicNavItemView } from '@zola/svc-web-api-ts-client';
import { ThemeContext } from '../../context';
import NamesModule from './NamesModule';
import LocationDateModule from './LocationDateModule';
import DateCountdown from './DateCountdown';
import StorySection from './StorySection';
import FooterImage from './FooterImage';

type HomeProps = {
  pageData?: WCmsHomepageView;
};

const Home = React.forwardRef((props: HomeProps, ref: React.ForwardedRef<HTMLDivElement>) => {
  const { pageData } = props;
  const { footer_image_url, homepage_sections: entities, video } = pageData || {};
  const {
    components: { Button, globalBodyFontStyle },
    wedding,
  } = useContext(ThemeContext);
  const { nav_items = [] } = wedding || {};
  const showRSVP =
    nav_items.filter(n => n.type === (('RSVP' as unknown) as WPublicNavItemView.TypeEnum)).length >
    0;

  const RSVPButton = styled(Button)`
    margin-top: 84px;
    width: 300px;
  `;
  const RSVPButtonContainer = styled.div`
    // TODO: TEXT-ALIGNMENT
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  const Hashtag = styled.div`
    ${globalBodyFontStyle}
    // TODO: TEXT-ALIGNMENT
    text-align: center;
  `;

  const {
    owner_first_name,
    owner_last_name,
    partner_first_name,
    partner_last_name,
    hashtag,
    wedding_date_range_start,
    wedding_date,
  } = wedding || {};

  return (
    <div ref={ref}>
      <NamesModule
        ownerFirstName={owner_first_name}
        ownerLastName={owner_last_name}
        partnerFirstName={partner_first_name}
        partnerLastName={partner_last_name}
      />
      {hashtag && <Hashtag>#{hashtag}</Hashtag>}
      <LocationDateModule wedding={wedding} />
      {wedding_date && (
        <DateCountdown startDate={wedding_date_range_start?.toString() || wedding_date} />
      )}
      {showRSVP && (
        <RSVPButtonContainer>
          <RSVPButton>RSVP</RSVPButton>
        </RSVPButtonContainer>
      )}
      <StorySection homepageSections={entities} video={video} />
      <FooterImage imageUrl={footer_image_url} />
    </div>
  );
});

export default Home;
